export default "__VITE_ASSET__BC1EKa0g__"